module.exports = __webpack_public_path__ + "static/media/WebCasinoThai.1016987e.webm";